var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.168 10.874a.5.5 0 1 0 .664-.748L6.664 6.422a1 1 0 0 0-1.328 0l-4.168 3.704a.5.5 0 0 0 .664.748L6 7.169zm0-5a.5.5 0 0 0 .664-.748L6.664 1.422a1 1 0 0 0-1.329 0L1.168 5.126a.5.5 0 0 0 .664.748L6 2.169z",
    clipRule: "evenodd"
  })));
});
const SvgDoubleChevronUpsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleChevronUpsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4xNjc4IDEwLjg3MzdDMTAuMzc0MiAxMS4wNTcyIDEwLjY5MDIgMTEuMDM4NiAxMC44NzM3IDEwLjgzMjJDMTEuMDU3MiAxMC42MjU4IDExLjAzODYgMTAuMzA5NyAxMC44MzIyIDEwLjEyNjNMNi42NjQzNiA2LjQyMTU2QzYuMjg1NDcgNi4wODQ3OCA1LjcxNDUyIDYuMDg0NzggNS4zMzU2MyA2LjQyMTU2TDEuMTY3ODEgMTAuMTI2M0MwLjk2MTQyMSAxMC4zMDk3IDAuOTQyODMxIDEwLjYyNTggMS4xMjYyOSAxMC44MzIyQzEuMzA5NzUgMTEuMDM4NiAxLjYyNTc4IDExLjA1NzIgMS44MzIxOCAxMC44NzM3TDUuOTk5OTkgNy4xNjg5N0wxMC4xNjc4IDEwLjg3MzdaTTEwLjE2NzYgNS44NzM2OUMxMC4zNzQgNi4wNTcxNSAxMC42OSA2LjAzODU2IDEwLjg3MzUgNS44MzIxNkMxMS4wNTcgNS42MjU3NyAxMS4wMzg0IDUuMzA5NzQgMTAuODMyIDUuMTI2MjhMNi42NjQxNiAxLjQyMTU1QzYuMjg1MjcgMS4wODQ3NiA1LjcxNDMyIDEuMDg0NzYgNS4zMzU0MyAxLjQyMTU1TDEuMTY3NjEgNS4xMjYyOEMwLjk2MTIyMyA1LjMwOTc0IDAuOTQyNjMzIDUuNjI1NzcgMS4xMjYwOSA1LjgzMjE2QzEuMzA5NTUgNi4wMzg1NiAxLjYyNTU5IDYuMDU3MTUgMS44MzE5OCA1Ljg3MzY5TDUuOTk5OCAyLjE2ODk2TDEwLjE2NzYgNS44NzM2OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";